// extracted by css-extract-rspack-plugin
export default {"root":"Ie5cu8","prefix":"VusjgF","avatar":"yj1xje"};